import React from "react";
import { Modal, Form, Input, Button, Radio, Dropdown ,Space, Select} from "antd";

import "./groupAddModal.scss";
import useGroupStore from "../../store/groupModal.store";

export default function GroupAddModal() {
    const { isModalOpenG, handleModalGCancel, handleGroupAdd } = useGroupStore();
    const [form] = Form.useForm();

    const handleFormSubmit = (value) => {

        handleGroupAdd(value.groupname);
        handleModalGCancel();
        form.resetFields();
    };

    return (
        <Modal
            title= {"Add / Remove Group/BU"}
            visible={isModalOpenG}
            footer={null}
            onCancel={handleModalGCancel}
            className="subUserAddModel-title"
        >
            <Form
                    labelCol={{ flex: "150px" }}
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{ flex: 1 }}
                    colon={false}
                    onFinish={handleFormSubmit}
                    form={form}
            >               
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Add New Group Name",
                            },
                        ]}
                        label="Group Name"
                        name="groupname"
                    >
                        <Input   className="subUserAddModel-input"/>
                    </Form.Item>
                    <Button htmlType="submit" type="primary">
                        Submit
                    </Button>
            </Form>
        </Modal>
    );
}
